import Plant from '@/services/v2/plant'
import { filterSelectablePlants } from '@/helpers/plants'

// Shared plumbing behind the Production plant pickers. A view gets:
//  - `hasGroupPlants` / `groupPlants` for the b-select shown to groups that are
//    scoped to specific sites,
//  - `plants` for the searchable multiselect offered to groups with no site
//    restriction, with the hidden plants removed,
//  - `allPlants` for resolving ids on existing records, where a hidden plant
//    still has to show its real name,
//  - `loadPlants()`, which only hits the API when the view actually needs the
//    full list.
export default {
  data () {
    return {
      allPlants: []
    }
  },
  computed: {
    plants () {
      return filterSelectablePlants(this.allPlants)
    },
    groupPlants () {
      const assigned = this.$store.state.auth.user?.group?.plants || []
      const selectable = filterSelectablePlants(assigned)
      // A group granted nothing but hidden plants would be left with an empty
      // picker, so fall back to what the admin actually granted.
      return selectable.length !== 0 ? selectable : assigned
    },
    hasGroupPlants () {
      return this.groupPlants.length !== 0
    },
    // Used by the all-sites grids, which show a plant name per row.
    plantNamesById () {
      const source = this.allPlants.length !== 0 ? this.allPlants : this.groupPlants
      return source.reduce((acc, plant) => {
        acc[String(plant.id)] = plant.name
        return acc
      }, {})
    }
  },
  methods: {
    // A group scoped to its own sites picks from `groupPlants` and never needs
    // the full list. `force` is for the views that read every plant regardless:
    // the all-sites grids, the SAP lookup and world stock.
    async loadPlants ({ force = false } = {}) {
      if (!force && this.hasGroupPlants) {
        return
      }
      this.allPlants = await Plant.getAll()
    }
  }
}
